const Footer = {
  handleSubmenu: function () {
    const toggles = document.querySelectorAll('[data-action="toggle-menu-footer"]');

    toggles.length > 0 && toggles.forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const menuItem = toggle.closest('.menu-item');
        if (!menuItem) return;

        const isOpen = menuItem.classList.toggle('-open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  },
  init: function () {
    const _this = this;

    _this.handleSubmenu();
  },
};

export default Footer;
